import {ACTION_CODE} from './_actionCode';
import {LoggerService} from '../../services';
import {CustomerService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';

const FUNCTION_CODE = 'GET_DEAL_RECIPIENTS';

export async function getDealRecipients(
    userData: Record<string, string>,
    dealId: number
) {
    try {
        LoggerService.logInfo('Action - getDealRecipients - Start');

        const recipients = await CustomerService.getDealRecipients(userData, dealId);

        LoggerService.logInfo('Action - getDealRecipients - End - Success');

        return ResultModel.newSuccessResult(recipients);
    }
    catch (error) {
        LoggerService.logInfo('Action - getDealRecipients - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des destinataires de l\'affaire.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
